import React, {useEffect, Fragment } from 'react'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import { checkUserSession } from './redux/User/user.actions';
import { useDispatch } from 'react-redux';
import WithAuth from './hoc/withAuth';
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollButton from '../src/components/ScrollBotton/ScrollButton';
import { Content, Heading } from '../src/components/ScrollBotton/Styles';

//public
import HomePage from "../src/pages/public/Homepage/HomePage"
import Community from "../src/pages/public/Community/Community"
import About from "../src/pages/public/About/About"
import Login from "../src/pages/public/Login/Login"
import Signup from "../src/pages/public/Signup/Signup"
import ForgotPassword from "../src/pages/public/ForgotPassword/ForgotPassword"

//private
import PrivateHomePage from "../src/pages/private/PrivateHomepage/PrivateHompage"
import PrivateAbout from "../src/pages/private/PrivateAbout/PrivateAbout"
import PrivateCommunity  from "../src/pages/private/PrivateCommunity/PrivateCommunity"
import ProfileUrl from "../src/pages/private/ProfileUrl/ProfileUrl"
import AddLinks from "../src/pages/private/AddLinks/AddLinks"
import SetupProfilePage from "../src/pages/private/SetupProfilePage/SetupProfilePage"
import LinkAdded from  "../src/pages/private/LinkAdded/LinkAdded"




const App = () => {

  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
  }, [])
  

  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(checkUserSession());
  //   window.scrollTo(0, 0);
  // }, [] );



  return (

    <Fragment>
    <Router>

      <Switch>

      <Route path="/login" render={() => (<Login/>)}  />
      <Route path="/signup" render={() => (<Signup/>)}  />
      <Route path="/forgotPassword" render={() => (<ForgotPassword/>)}  />

      <Route exact path="/" render={() => (<HomePage/>)} />
      <Route path="/community" render={() => (<Community/>)}  />
      <Route path="/about" render={() => (<About/>)}  />

      <Route path="/homepage" render={() => (
            <WithAuth>
          <PrivateHomePage/>
          </WithAuth>
      )} />

        
      <Route path="/privateAbout" render={() => (
            <WithAuth>
          <PrivateAbout />
          </WithAuth>
      )} />

         <Route path="/addLinks" render={() => (
            <WithAuth>
          <AddLinks />
          </WithAuth>
      )} />

    <Route path="/linkAdded" render={() => (
            <WithAuth>
          <LinkAdded />
          </WithAuth>
      )} />

    <Route path="/setupProfile" render={() => (
            <WithAuth>
          <SetupProfilePage />
          </WithAuth>
      )} />

    <Route path="/profileUrl" render={() => (
            <WithAuth>
          <ProfileUrl />
          </WithAuth>
      )} />

      
    <Route path="/privateCommunity" render={() => (
            <WithAuth>
          <PrivateCommunity />
          </WithAuth>
      )} />
      
       
      </Switch>
    </Router>

    <ScrollButton />
    
    </Fragment>
  )
}

export default App
